const services = [
  {
    title: "General Consultation",
    desc: "Expert clinical advice for routine, preventive, and long-term care requirements.",
  },
  {
    title: "Nutrition & Wellness",
    desc: "Personalized nutrition programs designed to support health and lifestyle goals.",
  },
  {
    title: "Diagnostic Support",
    desc: "Comprehensive diagnostics, structured reports, and insights for better care decisions.",
  },
  {
    title: "Chronic Care Management",
    desc: "Condition-specific programs that help you track, manage, and understand your health.",
  },
];

export default function Services() {
  return (
    <section className="py-20 bg-muted/30">
      <div className="max-w-7xl mx-auto px-6">
        <h2 className="text-3xl font-semibold text-foreground mb-10 text-center">
          Our Healthcare Services
        </h2>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
          {services.map((s, i) => (
            <div
              key={i}
              className="p-6 rounded-lg bg-card border border-border shadow-sm"
            >
              <h3 className="text-xl font-medium text-primary">{s.title}</h3>
              <p className="mt-3 text-muted-foreground">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
